export default "__VITE_ASSET__DZWD06W___"